export class LazySet {
  constructor(elem) {
    this.polymerElement = elem;
    this.modifiedPaths = [];
  }
  set(path, value) {
    let parent = this.polymerElement;
    let parts = path.split('.');
    parts.slice(0, -1).forEach((key) => {
      if (parent) parent = parent[key];
    });
    if (parent) {
      parent[parts.slice(-1)[0]] = value;
      // Filter out any paths that are this path or subpaths of this path.
      this.modifiedPaths = this.modifiedPaths.filter((modifiedPath) => !modifiedPath.startsWith(path));
      // Only add this path if there are no paths that this path is equal to or a subpath of.
      if (this.modifiedPaths.find((modifiedPath) => path.startsWith(modifiedPath)) == null) this.modifiedPaths.push(path);
    }
  }

  notify() {
    this.modifiedPaths.forEach((path) => this.polymerElement.notifyPath(path));
    this.modifiedPaths = [];
  }
}
